module.exports = __webpack_public_path__ + "static/rnb-reactive-1f43e225c962e2af50d3e9b35987e045.png";